<template>
  <div>
    <!-- Contenido visible en pantallas grandes -->
    <v-row class="d-none d-md-flex">
      <v-col
        cols="12"
        md="5"
      >
        <koiote-date-picker
          :dateLabel="'Fecha Inicio'"
          :hourLabel="'Hora Inicio'"
          :type="1"
          @cambio="cambio_en_fecha_hora_inicio"
        ></koiote-date-picker>
      </v-col>
      <v-col
        cols="12"
        md="5"
      >
        <koiote-date-picker
          :dateLabel="'Fecha Fin'"
          :hourLabel="'Hora Fin'"
          :type="2"
          @cambio="cambio_en_fecha_hora_fin"
        ></koiote-date-picker>
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="d-flex align-self-center"
      >
        <v-btn
          block
          @click="buscar(1)"
        >
          Buscar
        </v-btn>
      </v-col>
    </v-row>

    <!-- Botón para mostrar modal en pantallas pequeñas -->
    <div class="d-flex d-md-none">
      <v-btn
        block
        @click="showModal = true"
      >
        Mostrar Filtro
      </v-btn>
    </div>

    <!-- Modal para pantallas pequeñas -->
    <v-dialog
      v-model="showModal"
      max-width="600px"
    >
      <v-card>
        <v-card-title class="headline">Filtros</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              md="5"
            >
              <koiote-date-picker
                :dateLabel="'Fecha Inicio'"
                :hourLabel="'Hora Inicio'"
                :type="1"
                @cambio="cambio_en_fecha_hora_inicio"
              ></koiote-date-picker>
            </v-col>
            <v-col
              cols="12"
              md="5"
            >
              <koiote-date-picker
                :dateLabel="'Fecha Fin'"
                :hourLabel="'Hora Fin'"
                :type="2"
                @cambio="cambio_en_fecha_hora_fin"
              ></koiote-date-picker>
            </v-col>
            <v-col
              cols="12"
              md="2"
              class="d-flex align-self-center"
            >
              <v-btn
                block
                @click="buscar(2)"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            color="primary"
            text
            @click="showModal = false"
            >Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import axios from "axios";
// import moment from "moment-timezone";
import { mapState, mapActions } from "vuex";
import KoioteDatePicker from "@/components/utils/KoioteDatePicker.vue";
import axios from "axios";

export default {
  props: {
    input: Object,
  },
  components: {
    KoioteDatePicker,
  },
  data() {
    return {
      showModal: false,
      fechaHoraInicio: null,
      fechaHoraFin: null,
      inputModificado: null,
    };
  },
  computed: {
    ...mapState(["selectedItem"]),
  },

  // watch: {
  //   inputModificado: {
  //     handler() {
  //       console.log("SE HA MODIFICADO EL INPUT!");
  //     },
  //     deep: true,
  //   },
  // },

  mounted() {
    this.inputModificado = this.input;
  },
  methods: {
    ...mapActions(["getData"]),
    cambio_en_fecha_hora_inicio(fechahora) {
      this.fechaHoraInicio = fechahora; // moment(fechahora).format("YYYY-MM-DD HH:mm:ss");
      console.log(this.inputModificado.customized);
      // Verifica si this.inputModificado.customized.valorFechas existe
      if (!this.inputModificado.customized.valorFechas) {
        // Si no existe, inicialízalo como un objeto vacío
        this.$set(this.inputModificado.customized, "valorFechas", {});
      }

      // Asigna el valor a la propiedad inicio dentro de valorFechas
      this.$set(this.inputModificado.customized.valorFechas, "inicio", fechahora);
      this.inputModificado.customized.valorFechas.inicio = fechahora;
    },
    cambio_en_fecha_hora_fin(fechahora) {
      this.fechaHoraFin = fechahora; // moment(fechahora).format("YYYY-MM-DD HH:mm:ss");
      if (!this.inputModificado.customized.valorFechas) {
        // Si no existe, inicialízalo como un objeto vacío
        this.$set(this.inputModificado.customized, "valorFechas", {});
      }
      this.$set(this.inputModificado.customized.valorFechas, "fin", fechahora);
      this.inputModificado.customized.valorFechas.fin = fechahora;
    },
    // Función para eliminar elementos consecutivos con el mismo valor
    removeConsecutiveDuplicates(array) {
      if (array.length === 0) return [];

      // Inicializamos el array resultante con el primer elemento
      const result = [array[0]];

      // Recorremos el array a partir del segundo elemento
      for (let i = 1; i < array.length; i++) {
        // Comparamos el valor del elemento actual con el valor del último elemento en result
        if (array[i].value !== result[result.length - 1].value) {
          // Si son diferentes, agregamos el elemento al array result
          result.push(array[i]);
        }
      }

      return result;
    },
    async buscar(i) {
      if (this.fechaHoraFin != null && this.fechaHoraInicio != null) {
        const nuevoObjeto = this.input;
        nuevoObjeto.customized.data = [];
        let ruta = this.input.customized.rutaApi;
        ruta += "?";
        ruta += `${this.input.customized.fechaInicio}=${encodeURIComponent(this.fechaHoraInicio)}`;
        ruta += `&${this.input.customized.fechaFin}=${encodeURIComponent(this.fechaHoraFin)}`;
        if (this.input.customized.otros.length > 0) {
          ruta += `&${this.input.customized.otros}`;
        }
        console.log(ruta);
        axios.get(ruta).then((res) => {
          const dataListCopy = [...res.data]; // Copia del array
          const filteredDataList = this.removeConsecutiveDuplicates(dataListCopy);
          nuevoObjeto.customized.data = filteredDataList;
          //Hay que añadir un elemento nuevo con la fecha fin del filtro
          const ultimoRegistro = filteredDataList[filteredDataList.length - 1];
          nuevoObjeto.customized.data.push(ultimoRegistro);
        });
      }
      //Si es pequeño cerrar modal
      if (i == 2) this.showModal = false;
    },
  },
};
</script>
